import React from "react";

const NotFound = () => {
  return <div>Error 404 : This page does not exist </div>;
};

export default NotFound;
